import MyVideosIcon from '@mui/icons-material/SubscriptionsRounded';
import PlanIcon from '@mui/icons-material/ViewWeekRounded';
import AccountIcon from '@mui/icons-material/PersonRounded';
import SupportIcon from '@mui/icons-material/ContactSupportRounded';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'; 
import PeopleIcon from '@mui/icons-material/People';
import TuneIcon from '@mui/icons-material/Tune';
import ImportExportIcon from '@mui/icons-material/ImportExport'
import { AnalyticsConstants } from '../../../utilities/analyticsUtilities';

const navigationItems = [
  {
    path: '/videos',
    label: 'My Videos',
    icon: MyVideosIcon,
    analytics: null,
    bottomDivider: false
  },
  {
    path: '/plans',
    label: 'Plans',
    icon: PlanIcon,
    analytics: null,
    bottomDivider: false
  },
  {
    path: '/account',
    label: 'Account',
    icon: AccountIcon,
    analytics: null,
    bottomDivider: true
  },
  {
    label: 'Admin Panel',
    icon: AdminPanelSettingsIcon,
    bottomDivider: false,
    analytics: null,
    roles: ['Admin'],
    children: [
      {
        path: '/admin/users',
        label: 'Users',
        icon: PeopleIcon
      },
      {
        path: '/admin/presets',
        label: 'Presets',
        icon: TuneIcon
      },
      {
        path: '/admin/exports',
        label: 'Exports Queue',
        icon: ImportExportIcon
      }
    ]
  },
  {
    path: '/support',
    label: 'Support',
    icon: SupportIcon,
    bottomDivider: false,
    analytics: {
      eventName: 'Clicked Support',
      category: AnalyticsConstants.MISC_CATEGORY
    } 
  }
];

export default navigationItems;